export * from './gvp-video.component';
